import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import type {
  CitationBlockStateType,
  CitationComponentType,
} from '@unifyapps/defs/blocks/Citation/types';
import { lazy } from 'react';

const importCitation = () =>
  import(
    /* webpackChunkName: "citation-block" */
    './Citation'
  );

const Citation = lazy(importCitation);

export class CitationBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Citation;
  }

  preload() {
    return {
      blockPreload: importCitation,
    };
  }

  get type(): ComponentTypeUnionType {
    return 'Citation';
  }

  useBlockRef?: boolean | undefined = true;

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as CitationComponentType, [
          'content',
          'appearance',
          'componentType',
        ]),
      }) as CitationBlockStateType;
  }
}
